import React, { useState } from "react";
import { styled } from "@mui/material/styles";
import { useFormikContext } from "formik";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import AdvancedSettings from "./AdvancedSettings";
import EditIcon from "@mui/icons-material/Edit";
import Tooltip from "@mui/material/Tooltip";

const PREFIX = "FullScreenDialog";

const classes = {
  appBar: `${PREFIX}-appBar`,
  title: `${PREFIX}-title`,
  left_aligned_button: `${PREFIX}-left_aligned_button`,
  root: `${PREFIX}-root`,
  layout: `${PREFIX}-layout`,
  buttonMargin: `${PREFIX}-buttonMargin`,
};

const Root = styled("div")(({ theme }) => ({
  [`& .${classes.appBar}`]: {
    position: "relative",
  },

  [`& .${classes.title}`]: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },

  [`& .${classes.left_aligned_button}`]: {
    marginTop: theme.spacing(3),
    marginRight: theme.spacing(1),
  },

  [`& .${classes.root}`]: {
    position: "relative",
    display: "flex",
    justifyContent: "center",
    gap: "16px",
    flexDirection: "column",
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    boxShadow: "unset",
    [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
      marginBottom: theme.spacing(6),
      padding: theme.spacing(3),
    },
  },

  [`& .${classes.layout}`]: {
    width: "auto",
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(2) * 2)]: {
      width: 600,
      marginLeft: "auto",
      marginRight: "auto",
    },
  },

  [`& .${classes.buttonMargin}`]: {
    marginRight: theme.spacing(2),
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function FullScreenDialog(props) {
  const { values, setValues } = useFormikContext();
  const [open, setOpen] = React.useState(false);
  const [InitialData, setInitialData] = useState();

  const handleClickOpen = () => {
    setOpen(true);
    setInitialData(values);
  };

  const handleCancel = () => {
    setOpen(false);
    setValues(InitialData);
  };

  const handleSave = () => {
    setOpen(false);
  };

  return (
    <Root>
      {props.icon ? (
        <Tooltip title="Edit" placement="left">
          <IconButton
            className={classes.buttonMargin}
            onClick={handleClickOpen}
            onFocus={(event) => event.stopPropagation()}
            size="large"
          >
            <EditIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      ) : (
       <Button
  className={`button-tertiary ${classes.left_aligned_button}`}
  onClick={handleClickOpen}
>
  Advanced Settings
</Button>
      )}
      <Dialog fullScreen open={open} TransitionComponent={Transition}>
        <AppBar className={classes.appBar}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleCancel}
              aria-label="close"
              size="large"
            >
              <CloseIcon />
            </IconButton>
            <Typography
              variant="h6"
              className={classes.title}
              component={"span"}
            >
              Advanced Settings
            </Typography>
            <Button autoFocus color="inherit" onClick={handleSave}>
              save
            </Button>
          </Toolbar>
        </AppBar>
        <Box className={classes.layout}>
          <Paper className={classes.root}>
            <AdvancedSettings />
          </Paper>
        </Box>
      </Dialog>
    </Root>
  );
}
